import { axios } from '@/utils/request';

let Api = {
  getFileList: '/file/list', // 文件列表
  fileDelete: '/file/delete', // 删除文件
  isRead: '/file/IsRead', // 是否已读文件
  downLoadFile: '/file/download', // 下载文件
};

// 文件列表
export const getFileListApi = (params) => {
  return axios.get(Api.getFileList, { params });
};

// 删除文件
export const fileDeleteApi = (params) => {
  return axios.get(Api.fileDelete, { params });
};

// 是否已读文件
export const isReadApi = () => {
  return axios.get(Api.isRead);
};

// 下载文件
export const downLoadFileApi = (params) => {
  return axios.get(
      Api.downLoadFile,
      { params,responseType: "blob" },
  );
}
